import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { ISalesInvoicesStatusEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ISalesInvoicesStatusEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.salesInvoicesStatus");

export const salesInvoicesStatus = {
  ...getAllApis,
};
